import { InfoWindow } from "@react-google-maps/api";

import { type IMark } from "commonComponents/entity/map/Map.types";

interface ICustomInfoWindowProps {
    mark: IMark;
    onCloseClick: () => void;
    onClick?: () => void;
}

const CustomInfoWindow: React.FunctionComponent<ICustomInfoWindowProps> = ({
    mark,
    onCloseClick,
    onClick,
}) => {
    const options: google.maps.InfoWindowOptions = {
        pixelOffset: new google.maps.Size(0, -32),
    };

    return (
        <InfoWindow
            key={`${mark.id}-infoWindow`}
            position={mark.position}
            options={options}
            onCloseClick={onCloseClick}
        >
            {onClick ? (
                <div onClickCapture={onClick} style={{ cursor: "pointer" }}>
                    {mark.infoWindowContent}
                </div>
            ) : (
                mark.infoWindowContent
            )}
        </InfoWindow>
    );
};

export default CustomInfoWindow;
